import styled from "styled-components";
import { MenuItem } from "@mui/material";
import MUIMenu from "@mui/material/Menu";

import { ButtonMenu } from "@/components/atoms";
import { breakpoints } from "@/styles/breakpoints";

export const StyledLinkButtonDropdown = styled(ButtonMenu)`
    padding-right: 25px;
    margin-left: auto;
    font-size: var(--size-14);
    font-weight: var(--weight-600);
    color: var(--color-secondary);

    &.active::after,
    &:hover::after {
        height: 0px;
    }

    @media ${breakpoints.mdMax} {
        padding-top: 10px;
    }
    @media ${breakpoints.xxs} {
        margin-left: 0;
    }

    svg {
        width: 19px;
        height: 19px;
        margin-right: 4px;
        vertical-align: bottom;

        path {
            fill: var(--color-secondary);
        }
    }
`;

export const StyledLinkDropdownPopover = styled(MUIMenu)`
    .MuiList-padding {
        padding-top: 0;
        padding-bottom: 0;
    }
`;

export const StyledLinkDropdownMenuItem = styled(MenuItem)`
    padding: 10px 20px;
    border-bottom: 2px solid var(--color-grey-500);

    svg {
        margin-right: 4px;
    }

    @media ${breakpoints.sm} {
        padding: 15px 20px;
    }

    &:last-child {
        border: none;
    }
`;
